import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
const PROOFS = [{
  id: 'doing',
  metric: 'From chatting to doing',
  quote: '"Giga doesn\'t just suggest what to do—it actually executes the work across our entire stack."',
  author: {
    name: 'Sarah Jenkins',
    role: 'VP of Operations at TechFlow',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80'
  }
}, {
  id: 'hours',
  metric: 'Hours saved every week',
  quote: '"The context switching is gone. Giga handles the busywork so we can focus on actual strategy."',
  author: {
    name: 'Marcus Chen',
    role: 'Director of Growth',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&q=80'
  }
}, {
  id: 'execution',
  metric: '10x faster execution',
  quote: '"We just tell Giga the outcome we want, and it orchestrates the entire workflow instantly."',
  author: {
    name: 'Elena Rodriguez',
    role: 'Founder & CEO',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=150&q=80'
  }
}, {
  id: 'tools',
  metric: 'Zero new tools to learn',
  quote: '"It lives right where we already work. No new dashboards, no complex setup required."',
  author: {
    name: 'David Kim',
    role: 'Head of Revenue Operations',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80'
  }
}];
export function ProofPointsGrid() {
  return <section aria-label="Proof points from teams using Giga" className="w-full bg-[#1A1410] py-24 md:py-32" data-id="element-2293">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-2294">
        <h2 className="sr-only" data-id="element-2295">What teams get with Giga</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto" data-id="element-2296">
          {PROOFS.map((proof, i) => <motion.div key={proof.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative flex flex-col justify-between p-8 md:p-10 rounded-3xl bg-[#2B211A] border border-white/[0.06] overflow-hidden group cursor-pointer min-h-[320px]" data-id="element-2297">
              <div className="absolute top-8 right-8 text-white/90 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-2298">
                <ArrowUpRight size={28} strokeWidth={1.5} data-id="element-2299" />
              </div>

              <div className="mb-12 md:mb-16 pr-12" data-id="element-2300">
                <h3 className="text-3xl md:text-4xl font-title font-medium text-[#F2A36A] mb-4 leading-tight tracking-tight" data-id="element-2301">
                  {proof.metric}
                </h3>
                <p className="text-lg text-white font-medium leading-relaxed" data-id="element-2302">
                  {proof.quote}
                </p>
              </div>

              <div className="flex items-center gap-4 mt-auto" data-id="element-2303">
                <img src={proof.author.avatar} alt={proof.author.name} className="w-12 h-12 rounded-full object-cover border border-white/10" data-id="element-2304" />
                <div data-id="element-2305">
                  <div className="text-white font-semibold text-sm md:text-base" data-id="element-2306">
                    {proof.author.name}
                  </div>
                  <div className="text-white/80 text-xs md:text-sm" data-id="element-2307">
                    {proof.author.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}